import config from '../config'
import CoreServices from './coreServices'
import { FRIEND } from '../constants/services'
import axios from 'axios'

class FriendServices extends CoreServices {
  async getFriends(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/friends`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        params: queries
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getRequestFriends() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/friends/requests`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async sendFriendRequest(receiverId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/friends/requests`, { receiverId: receiverId }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data || {}
    } catch (error) {
      return error?.response?.data || {}
    }
  }

  async cancelFriendRequest(relationshipId) {
    try {
      let response = await axios.delete(`${this.apiEnpointV1}/friends/${relationshipId}`,{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async acceptFriendRequest(relationshipId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/friends/${relationshipId}/accept`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async toggleFavorite(relationshipId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/friends/${relationshipId}/favorites`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async getFavorites() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/friends/favorites`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new FriendServices(FRIEND.BASE)
